import React from "react";

import Paper from "@mui/material/Paper";

const Highlights = () => {
  return (
    <>
      <Paper elevation={3}>
        <div className="p-5">
          <div className="row p-0 justify-content-center">
            <div className="col-md-12 text-center p-3 ">
              <div className=" pb-4">
                <h1 className="h1size">
                  Premier Institute Offering Nursing, Paramedical &
                  Physiotherapy Courses in Northeast India
                </h1>
                <h2 className="h2seo">PEWS: "With a Solution for a Brighter Tomorrow"</h2>
                <h2 className="text-dark">
                  {/* Highlights */}
                  HIGHLIGHTS
                </h2>
                <div>
                  <i>
                    Welcome to our Highlights section! Here, we bring you the
                    latest and greatest highlights from our world of offerings.{" "}
                  </i>
                </div>
              </div>

              <div className="row justify-content-center p-0 m-0">
                <div className="col-md-1 text-center p-3 bg-primary left-box-highlight">
                  <div className="text-white">{/* <h3> 100% </h3> */}</div>
                  <div className="text-white">{/* <b> Scholarships</b> */}</div>
                </div>
                <div className="col-md-2 text-center p-3 bg-primary border-right">
                  <div className="text-white">
                    <h3> 100% </h3>
                  </div>
                  <div className="text-white">
                    <b> Scholarships</b>
                  </div>
                </div>
                <div className="col-md-2 text-center p-3 bg-primary border-right">
                  <div className="text-white">
                    <h3> 20 </h3>
                  </div>
                  <div className="text-white">
                    <b> Years in Education</b>
                  </div>
                </div>
                <div className="col-md-2 text-center p-3 bg-primary border-right">
                  <div className="text-white">
                    <h3> 15+ </h3>
                  </div>
                  <div className="text-white">
                    <b> Hi-Tech Labs</b>
                  </div>
                </div>
                <div className="col-md-2 text-center p-3 bg-primary border-right">
                  <div className="text-white">
                    <h3> 4 </h3>
                  </div>
                  <div className="text-white">
                    <b> Schools</b>
                  </div>
                </div>
                <div className="col-md-2 text-center p-3 bg-primary">
                  <div className="text-white">
                    <h3> 10 + </h3>
                  </div>
                  <div className="text-white">
                    <b> Programmes</b>
                  </div>
                </div>
                <div className="col-md-1 text-center p-3 bg-primary right-box-highlight">
                  <div className="text-white"></div>
                  <div className="text-white"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Paper>
    </>
  );
};

export default Highlights;
